export const FLIGHT_PRODUCT_TYPE = "flight" as const;

export type FlightEventBasicProperties = {
  productType: typeof FLIGHT_PRODUCT_TYPE;
};

export type FlightEventProperties<Properties> = FlightEventBasicProperties &
  Properties;
